module.exports = __webpack_public_path__ + "img/9788991232341.2e23b4d8.jpg";